export function admin_vimeo_getThumbAjax(ajaxurl, resolve, featuredMediaVal) {





  var data = {
    action: 'dzsvg_vimeo_get_vimeothumb',
    postdata: featuredMediaVal
  };

  jQuery.post(ajaxurl, data, function (response) {
    if (response.substr(0, 6) === 'error:') {

      alert(response.substr(7));
      jQuery('.import-error').fadeIn('fast').delay(5000).fadeOut('slow');
      return false;
    }
    resolve(response);

  });
}
